import { FormSection, Radio } from '@ksyos/design-system';
import {
    OorkRedenKeuring,
    RijbewijsCategorie,
} from '@common/interfaces/ophthalmology/OorkAndOcrk/oorkV1ProcedureCustomControlData';
import { getValuesFromEnum } from '@common/utils/getValuesFromEnum';
import { BooleanRadioGroupFormGroupField } from '@frontend/components/fields/BooleanRadioGroupField';
import { RadioGroupFormGroupField } from '@frontend/components/fields/RadioGroupField';
import { SelectFormGroupField } from '@frontend/components/fields/SelectField';
import { TextAreaFormGroupField } from '@frontend/components/fields/TextAreaField';
import { translateKey } from '@frontend/translate';
import type { IOorkV1ProcedureProps } from './types';
import { defaultBooleanRadioGroupFormGroupFieldProps, defaultTextAreaFormGroupFieldProps } from './types';

export function OorkV1ProcedureAnamnesis(props: IOorkV1ProcedureProps) {
    return (
        <FormSection title={translateKey('carePlan.anamnese')}>
            <SelectFormGroupField
                fieldKey="reden_van_keuring"
                isRequired={true}
                label="Reden van keuring"
                onChange={async (value) => {
                    if (props.customControlData.reden_van_keuring === value) {
                        return;
                    }

                    await props.handleChangeCustomControl({
                        overige_reden_van_keuring: null,
                        reden_van_keuring: value,
                    });
                }}
                options={Object.values(OorkRedenKeuring).map((enumValue) => ({
                    label: enumValue,
                    value: enumValue,
                }))}
                placeholder="Typ of kies uit de lijst..."
            />

            {props.customControlData.reden_van_keuring === OorkRedenKeuring.overig && (
                <TextAreaFormGroupField
                    {...defaultTextAreaFormGroupFieldProps}
                    fieldKey="overige_reden_van_keuring"
                    isRequired={true}
                    label="Overige reden van keuring"
                    placeholder="Omschrijf de reden van keuring..."
                />
            )}

            <TextAreaFormGroupField
                {...defaultTextAreaFormGroupFieldProps}
                fieldKey="overige_anamnese"
                label="Overige anamnese"
                placeholder="Overige anamnese..."
            />
            <BooleanRadioGroupFormGroupField
                {...defaultBooleanRadioGroupFormGroupFieldProps}
                fieldKey="betrokkene_bezit_rijbewijs"
                isRequired={true}
                label="Betrokkene in bezit van rijbewijs"
            />
            <BooleanRadioGroupFormGroupField
                {...defaultBooleanRadioGroupFormGroupFieldProps}
                fieldKey="legitimatie_betrokkene_gezien"
                isRequired={true}
                label="Legitimatie betrokkene gezien"
            />

            <RadioGroupFormGroupField
                fieldKey="categorie_rijbewijs"
                isRequired={true}
                label="Categorie rijbewijs"
            >
                {getValuesFromEnum(RijbewijsCategorie).map((value, index) => (
                    <Radio
                        key={index}
                        label={value}
                        value={value}
                    />
                ))}
            </RadioGroupFormGroupField>
        </FormSection>
    );
}
